module.exports = __webpack_public_path__ + "static/media/pic7.664cf4e3.jpg";